import { c as _c } from "react/compiler-runtime";
import { IcoFaceid24, IcoIdCard24, IcoShield24, IcoUserstore24 } from '@onefootprint/icons';
import { BottomSheet, Button, Dialog } from '@onefootprint/ui';
import { motion } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'usehooks-ts';
import { LEGACY_IDV_CONTAINER_ID as LAYOUT_CONTAINER_ID } from '@/idv2/components/constants';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import HeaderTitle from '../../../components/header-title';
import StickyBottomBox from '../../../components/sticky-bottom-box';
import ConsentText from './components/consent-text';
import MergedLogos from './components/merged-logos';
const mediaBreakpoints = {
  md: '900px'
};
type ConsentViewProps = {
  variant?: 'document' | 'selfie';
  isMobileDevice: boolean;
  tenantLogoUrl?: string;
  tenantName: string;
  tenantPrivacyPolicyUrl?: string;
  isLoading: boolean;
  consentTextOpen: boolean;
  onAgree: () => void;
  onNavigatedToPrev: () => void;
  onOpenConsentText: () => void;
  onCloseConsentText: () => void;
};
const ConsentView = t0 => {
  const $ = _c(95);
  const {
    variant: t1,
    isMobileDevice,
    tenantLogoUrl,
    tenantName,
    tenantPrivacyPolicyUrl,
    isLoading,
    consentTextOpen,
    onAgree,
    onNavigatedToPrev,
    onOpenConsentText,
    onCloseConsentText
  } = t0;
  const variant = t1 === undefined ? "document" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow.id-doc.pages.consent"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  const isMobile = useMediaQuery(`(max-width: ${mediaBreakpoints.md})`);
  const t3 = tenantPrivacyPolicyUrl ? "document-flow.id-doc.pages.consent.privacy-policy-text-with-tenant" : "document-flow.id-doc.pages.consent.privacy-policy-text-without-tenant";
  let t4;
  if ($[1] !== tenantName) {
    t4 = {
      tenantName
    };
    $[1] = tenantName;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onOpenConsentText) {
    t5 = e => {
      if (e.key === "Enter") {
        e.preventDefault();
        onOpenConsentText();
      }
    };
    $[3] = onOpenConsentText;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onOpenConsentText || $[6] !== t5) {
    t6 = <span role="button" tabIndex={0} className="text-secondary underline cursor-pointer" onClick={onOpenConsentText} onKeyDown={t5} />;
    $[5] = onOpenConsentText;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <a className="text-secondary underline cursor-pointer" href="https://www.onefootprint.com/privacy-policy" rel="noopener noreferrer" target="_blank" aria-label="Read Footprint Privacy Policy"><span className="sr-only">{t7}</span></a>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `Read ${tenantName}'s Privacy Policy`;
  let t10;
  if ($[12] !== t || $[13] !== tenantName) {
    t10 = t(_temp2, {
      tenantName
    });
    $[12] = t;
    $[13] = tenantName;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <span className="sr-only">{t10}</span>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t9 || $[19] !== tenantPrivacyPolicyUrl) {
    t12 = <a className="text-secondary underline cursor-pointer" href={tenantPrivacyPolicyUrl} rel="noopener noreferrer" target="_blank" aria-label={t9}>{t11}</a>;
    $[17] = t11;
    $[18] = t9;
    $[19] = tenantPrivacyPolicyUrl;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6 || $[23] !== t8) {
    t13 = {
      bottomsheet: t6,
      fpPrivacyPolicy: t8,
      tenantPrivacyPolicy: t12
    };
    $[21] = t12;
    $[22] = t6;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t3 || $[27] !== t4) {
    t14 = <p className="text-caption-1 text-quaternary text-center"><Trans ns="idv2" i18nKey={t3} values={t4} components={t13} /></p>;
    $[25] = t13;
    $[26] = t3;
    $[27] = t4;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp3);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== isLoading || $[32] !== onAgree || $[33] !== t15) {
    t16 = <Button fullWidth={true} size="large" onClick={onAgree} loading={isLoading}>{t15}</Button>;
    $[31] = isLoading;
    $[32] = onAgree;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t14 || $[36] !== t16) {
    t17 = <div className="flex flex-col gap-3 items-center">{t14}{t16}</div>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const buttonContent = t17;
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      opacity: 0
    };
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      opacity: 1,
      transition: {
        duration: 0.3
      }
    };
    t20 = {
      opacity: 0
    };
    $[39] = t19;
    $[40] = t20;
  } else {
    t19 = $[39];
    t20 = $[40];
  }
  let t21;
  if ($[41] !== onNavigatedToPrev) {
    t21 = <NavigationHeader leftButton={{
      variant: "back",
      onBack: onNavigatedToPrev
    }} />;
    $[41] = onNavigatedToPrev;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== tenantLogoUrl || $[44] !== tenantName) {
    t22 = <MergedLogos tenantLogoUrl={tenantLogoUrl} tenantName={tenantName} />;
    $[43] = tenantLogoUrl;
    $[44] = tenantName;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t || $[47] !== tenantName) {
    t23 = t(_temp4, {
      tenantName
    });
    $[46] = t;
    $[47] = tenantName;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t) {
    t24 = t(_temp5);
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t23 || $[52] !== t24) {
    t25 = <HeaderTitle title={t23} subtitle={t24} display="flex" flexDirection="column" />;
    $[51] = t23;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== variant) {
    t26 = <div className="shrink-0">{variant === "selfie" ? <IcoFaceid24 color="primary" /> : <IcoIdCard24 color="primary" />}</div>;
    $[54] = variant;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== isMobileDevice || $[57] !== t || $[58] !== variant) {
    t27 = variant === "selfie" ? t(_temp6) : t($_5 => isMobileDevice ? $_5["take-a-photo"] : $_5["upload-a-photo"]);
    $[56] = isMobileDevice;
    $[57] = t;
    $[58] = variant;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t27) {
    t28 = <p className="text-label-2 text-primary mt-0.5">{t27}</p>;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t26 || $[63] !== t28) {
    t29 = <div className="flex flex-row gap-2 items-start">{t26}{t28}</div>;
    $[62] = t26;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="shrink-0"><IcoUserstore24 color="primary" /></div>;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== t) {
    t31 = t(_temp7);
    $[66] = t;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== t31) {
    t32 = <div className="flex flex-row gap-2 items-start">{t30}<p className="text-label-2 text-primary mt-0.5">{t31}</p></div>;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="shrink-0"><IcoShield24 color="primary" /></div>;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t || $[72] !== tenantName) {
    t34 = t(_temp8, {
      tenantName
    });
    $[71] = t;
    $[72] = tenantName;
    $[73] = t34;
  } else {
    t34 = $[73];
  }
  let t35;
  if ($[74] !== t34) {
    t35 = <div className="flex flex-row gap-2 items-start">{t33}<p className="text-label-2 text-primary mt-0.5">{t34}</p></div>;
    $[74] = t34;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t29 || $[77] !== t32 || $[78] !== t35) {
    t36 = <div className="flex flex-col w-full gap-5">{t29}{t32}{t35}</div>;
    $[76] = t29;
    $[77] = t32;
    $[78] = t35;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== t22 || $[81] !== t25 || $[82] !== t36) {
    t37 = <div className="flex flex-col items-center gap-6">{t22}{t25}{t36}</div>;
    $[80] = t22;
    $[81] = t25;
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== consentTextOpen || $[85] !== isMobile || $[86] !== onCloseConsentText) {
    t38 = isMobile ? <BottomSheet open={consentTextOpen} onClose={onCloseConsentText} containerId={LAYOUT_CONTAINER_ID}><ConsentText /></BottomSheet> : <Dialog open={consentTextOpen} onClose={onCloseConsentText} title=""><ConsentText /></Dialog>;
    $[84] = consentTextOpen;
    $[85] = isMobile;
    $[86] = onCloseConsentText;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== buttonContent) {
    t39 = <StickyBottomBox>{buttonContent}</StickyBottomBox>;
    $[88] = buttonContent;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== t21 || $[91] !== t37 || $[92] !== t38 || $[93] !== t39) {
    t40 = <motion.div className="flex flex-col flex-1 h-full" initial={t18} animate={t19} exit={t20}>{t21}{t37}{t38}{t39}</motion.div>;
    $[90] = t21;
    $[91] = t37;
    $[92] = t38;
    $[93] = t39;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  return t40;
};
export default ConsentView;
function _temp($) {
  return $["footprint-privacy-policy"];
}
function _temp2($_0) {
  return $_0["tenant-privacy-policy"];
}
function _temp3($_1) {
  return $_1["agree-and-continue"];
}
function _temp4($_2) {
  return $_2.title;
}
function _temp5($_3) {
  return $_3.subtitle;
}
function _temp6($_4) {
  return $_4["take-a-selfie"];
}
function _temp7($_6) {
  return $_6["footprint-securely-verifies"];
}
function _temp8($_7) {
  return $_7["your-data-encrypted"];
}